import { GoodsDto, GoodsStatus, OrderGoodsItemDto } from '../../api/ClientApi';
import { CompleteOrderType } from '../../common/Types';
import { RootState } from '../reducers';
import { BareGoodsEntity } from '../reducers/goodsToOrderFormReducer';

export function getBareGoodsForSite(
    orderType?: CompleteOrderType,
    orderedOrderGoodsItems?: OrderGoodsItemDto[],
): (state: RootState) => BareGoodsEntity[] | null {
    return function (state: RootState): BareGoodsEntity[] | null {
        const goods = state.goods.goods;
        let filteredGoods: GoodsDto[] = [];

        if (!orderType) {
            return [];
        }

        switch (orderType) {
            case CompleteOrderType.Transfer:
                const order = state.orderForm.order;

                filteredGoods = !order || !goods ? [] : goods.filter((g) => g.siteId === order.originSiteId);
                break;
            case CompleteOrderType.GeneralReturn:
                const returnOrder = state.returnOrderForm.returnOrder;

                filteredGoods =
                    !returnOrder || !goods ? [] : goods.filter((g) => g.siteId === returnOrder.originSiteId);
                break;
            default:
                filteredGoods = [];
        }

        if (!!filteredGoods) {
            const uniqueArticlesGoods = filteredGoods.filter(
                (value, index, array) => array.findIndex((g) => g.article?.id === value.article?.id) === index,
            );

            const bareGoods = uniqueArticlesGoods.map((ua) => {
                const row = filteredGoods.filter(
                    (fg) => fg.article?.id === ua.article?.id && fg.goodsStatus === GoodsStatus.InStock,
                );

                let availableQuantity = row.reduce((acc, val) => {
                    return (acc += val.quantity ?? 0);
                }, 0);

                availableQuantity -=
                    orderedOrderGoodsItems
                        ?.filter((fgi) => fgi.articleId === ua.article?.id)
                        .reduce((acc, val) => {
                            return (acc += val.quantity ?? 0);
                        }, 0) ?? 0;

                if (availableQuantity > 0) {
                    return {
                        article: ua.article,
                        availableQuantity,
                        orderedQuantity: 0,
                        goods: row,
                    } as BareGoodsEntity;
                } else {
                    return [];
                }
            });
            return bareGoods.flat();
        }
        return [];
    };
}

export function isOriginSiteKnown(state: RootState): boolean | null {
    const order = state.orderForm.order;
    const returnOrder = state.returnOrderForm.returnOrder;

    return !!order?.originSiteId || !!returnOrder;
}
